module.exports = __webpack_public_path__ + "images/user-black-placeholder.5004344f.png";